if (typeof globalThis.process === 'undefined') {
  globalThis.process = {
    env: {
      AWS_REGION: "ap-northeast-1"
    }
  };
}

import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom"; // Switchを使用
import { AuthProvider } from './contexts/AuthContext';
import RequireAuth from "./components/RequireAuth";
import AdminRoute from "./components/AdminRoute";

import { Amplify } from 'aws-amplify';
import awsExports from './aws-exports';

Amplify.configure(awsExports);

// ページコンポーネントのインポート
import HomePage from "./pages";
import SignPage from "./pages/signin/signin";
import Admin from "./pages/admin";
import Selling from "./pages/admin/selling";
import Users from "./pages/admin/users";
import Products from "./pages/admin/products";
//import Contacts from "./pages/admin/contacts";
import Profile from "./pages/profile";
import EditLoginInfo from "./pages/profile/login/editLoginInfo";
import EditSellerInfo from "./pages/profile/seller/edit";
import SellerRegistration from "./pages/profile/seller/new";
import ErrorBoundary from "./ErrorBoundary";
import PurchaseProduct from './pages/products/_UUID';
import EditProduct from './pages/products/edit/_UUID';
import CreateProduct from './pages/products/new';
import Customer from "./pages/customer";
import Dashboard from "./pages/dashboard";
import ProductDashboard from "./pages/dashboard/_productID";
import Default from "./layouts/default";
import ResetPasswordPage from './pages/signin/reset_password';
import RegisterPage from './pages/signin/register';
import NotFoundPage from './pages/404';
import StripeManual from "./pages/stripe_manual";
import StripeConnect from "./pages/striperedirect";
import ChangePasswordPage from './pages/signin/change-password';
import VerifyEmailPage from './pages/signin/verify-email';

const App = () => {
  return (
    <Router>
      <Default>
        <Switch>
        {/* "/" ルートで HomePage を表示 */}
        {/* 認証不要のページ */}
        <Route exact path="/signin" component={SignPage} />
        <Route exact path="/reset-password" component={ResetPasswordPage} />
        <Route path="/register" component={RegisterPage} />
        <Route exact path="/signin/change-password" component={ChangePasswordPage} />
        <Route path="/signin/verify-email" component={VerifyEmailPage} />

        {/* 管理者用ページ */}
        <Route exact path="/admin" render={() => (
          <RequireAuth>
            <AdminRoute>
              <Admin />
            </AdminRoute>
          </RequireAuth>
        )} />
        <Route exact path="/admin/selling" render={() => (
          <RequireAuth>
            <AdminRoute>
              <Selling />
            </AdminRoute>
          </RequireAuth>
        )} />
        <Route exact path="/admin/users" render={() => (
          <RequireAuth>
            <AdminRoute>
              <Users />
            </AdminRoute>
          </RequireAuth>
        )} />
        <Route exact path="/admin/products" render={() => (
          <RequireAuth>
            <AdminRoute>
              <Products />
            </AdminRoute>
          </RequireAuth>
        )} />

        {/* 通常の認証が必要なページ */}
        <Route exact path="/" render={() => (
          <RequireAuth>
            <HomePage />
          </RequireAuth>
        )} />
        <Route exact path="/profile" render={() => (
          <ErrorBoundary>
            <Profile />
          </ErrorBoundary>
        )} />
        <Route exact path="/profile/login/edit" render={() => (
          <RequireAuth>
            <EditLoginInfo />
          </RequireAuth>
        )} />
        <Route exact path="/profile/seller/edit" render={() => (
          <RequireAuth>
            <EditSellerInfo />
          </RequireAuth>
        )} />
        <Route exact path="/profile/seller/new" render={() => (
          <RequireAuth>
            <SellerRegistration />
          </RequireAuth>
        )} />
        <Route exact path="/products/new" render={() => (
          <RequireAuth>
            <CreateProduct />
          </RequireAuth>
        )} />
        <Route exact path="/products/edit/:UUID" render={(props) => (
          <RequireAuth>
            <EditProduct {...props} />
          </RequireAuth>
        )} />
        <Route exact path="/products/:UUID" render={(props) => (
            <PurchaseProduct {...props}/>
        )} />
        <Route exact path="/customer" render={() => (
          <RequireAuth>
            <Customer />
          </RequireAuth>
        )} />
        <Route exact path="/dashboard" render={() => (
          <RequireAuth>
            <Dashboard />
          </RequireAuth>
        )} />
        <Route exact path="/dashboard/:productID" render={(props) => (
          <RequireAuth>
            <ProductDashboard {...props} />
          </RequireAuth>
        )} />
        <Route exact path="/stripe_manual" render={(props) => (
          <RequireAuth>
            <StripeManual />
          </RequireAuth>
        )} />
        <Route exact path="/striperedirect" render={(props) => (
          <RequireAuth>
            <StripeConnect {...props} />
          </RequireAuth>
        )} />

        <Route path="*" component={NotFoundPage} />  {/* 404ページへの遷移 */}
        </Switch>
      </Default>
    </Router> 
  );
};

ReactDOM.render(
  <AuthProvider>
    <App />
  </AuthProvider>,
  document.getElementById('root')
);
